/**
 * Implements a badge component
 */
import ReactTooltip from 'react-tooltip';

import './styles.scss';

interface IBadgeProps {
  variant: 'fill';
  klass: 'grey' | 'red' | 'orange' | 'green';
  text: string;
  size?: number;
  weight?: number;
  padding?: string;
  borderRadius?: number;
  tooltip?: string;
}

const Badge = ({
  variant,
  klass,
  text,
  size = 12,
  weight = 400,
  padding = '0 8px',
  borderRadius = 28,
  tooltip,
}: IBadgeProps) => (
  <>
    <div
      className={`badge badge__${variant} badge__${variant}--${klass} text--${size} text--weight-${weight}`}
      style={{ padding, borderRadius }}
      {...(tooltip
        ? { 'data-for': `badge-${tooltip}-tooltip`, 'data-tip': tooltip }
        : {})}
    >
      {text}
    </div>
    {tooltip && (
      <ReactTooltip
        id={`badge-${tooltip}-tooltip`}
        place='bottom'
        effect='solid'
        multiline
        className='text_tooltip'
      />
    )}
  </>
);

export default Badge;
